import { useState } from "react";
import { fetchTableData } from "../../api/application/table-data";
import type { TableData } from "../../api/infrastructure/table-data.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetTableData() {
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = async ({ referenceId, tableId }: { referenceId: number; tableId: number }) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      const result = await fetchTableData({ referenceId, tableId });
      setTableData(result);
    });
    setLoading(false);
  };

  return { tableData, loadingTableData: loading, fetchTableData: fetch, setTableData };
}
